import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import TextField from "@mui/material/TextField";

import StockDetailChart from "../Components/StockDetailChart";

import TimeControl from "../Components/TimeControl";
import IndicatorSelector from "../Components/IndicatorSelector";
import { getCompanyInformation } from "../Service/data";

import { useTheme } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import { Button, Divider } from "@mui/material";

const LargeChartPage = () => {
  let [searchParams, setSearchParams] = useSearchParams();

  const [symbol, setSymbol] = useState("");
  const [indexStock, setIndexStock] = useState("");
  const [noData, setNoData] = useState(true);
  const [loading, setLoading] = useState(true);

  const [symbolField, setSymbolField] = useState("");
  const [indexField, setIndexField] = useState("");

  const theme = useTheme();

  useEffect(() => {
    const symbol = searchParams.get("symbol") || "";
    const indexStock = searchParams.get("indexStock") || "";
    if (indexStock) {
      setIndexStock(indexStock);
      setIndexField(indexStock);
    }
    if (symbol.length > 0) {
      setSymbol(symbol);
      setSymbolField(symbol);
    }
  }, []);

  const getIndexStock = async (symbol) => {
    try {
      getCompanyInformation(symbol).then((data) => {
        if (data) {
          console.log(data);
          if (data["country"]) {
            console.log(data);
            if (data["country"] === "United States") {
              setIndexStock("^SPX");
            } else if (data["country"] === "United Kingdom") {
              setIndexStock("^FTAS");
            } else {
              // Assuming Europe
              setIndexStock("^STOXX");
            }
          }
        }
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (symbol !== undefined && symbol !== null) {
      setLoading(false);
      setNoData(false);
      if (symbol.length > 0) getIndexStock(symbol);
      console.log(symbol);
    }
  }, [symbol]);

  const handeSaveClick = () => {
    // setIndexStock(indexField);
    setSymbol(symbolField);
  };

  useEffect(() => {
    if (!loading) {
      let params = new URLSearchParams(searchParams);
      if (symbol.length > 0) {
        if (params.get("symbol")) {
          if (params.get("symbol") !== symbol) {
            params.delete("symbol");
            params.append("symbol", symbol);
            setSearchParams(params);
          }
        } else {
          params.append("symbol", symbol);
          setSearchParams(params);
        }
      } else {
        if (params.get("symbol")) {
          params.delete("symbol");
          setSearchParams(params);
        }
      }
      if (indexStock.length > 0) {
        if (params.get("indexStock")) {
          if (params.get("indexStock") !== indexStock) {
            params.delete("indexStock");
            params.append("indexStock", indexStock);
            setSearchParams(params);
          }
        } else {
          params.append("indexStock", indexStock);
          setSearchParams(params);
        }
      } else {
        if (params.get("indexStock")) {
          params.delete("indexStock");
          setSearchParams(params);
        }
      }
    }
  }, [symbol, indexStock, searchParams, setSearchParams]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        paddingLeft: "10px",
        paddingRight: "30px",
        paddingTop: "20px",
        minHeight: "100vh",
        minWidth: "100vw",
        width: "fit-content",
        background: `${theme.palette.background.default}`,
      }}
    >
      <Stack direction="row" spacing={2}>
        <TextField
          style={{ width: "300px" }}
          id="outlined-basic"
          label="Symbol"
          variant="outlined"
          value={symbolField}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handeSaveClick();
            }
          }}
          onChange={(e) => {
            setSymbolField(e.target.value);
          }}
        />
        {/* <TextField
          style={{ width: "300px" }}
          id="outlined-basic"
          label="Divisor"
          variant="outlined"
          value={indexField}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handeSaveClick();
            }
          }}
          onChange={(e) => setIndexField(e.target.value)}
        /> */}
        <Button variant="outlined" onClick={handeSaveClick}>
          Save
        </Button>
      </Stack>
      <IndicatorSelector />
      <Typography component="h1" color="white">
        {symbol}
      </Typography>
      {loading && <CircularProgress />}
      {noData && symbol !== "" && <Typography>No data was received</Typography>}
      {symbol !== null && symbol !== undefined && !loading && (
        <>
          <div style={{ display: "flex", flexDirection: "row" }}>
            <StockDetailChart
              title="1 Day"
              symbol={symbol}
              width={600}
              height={600}
              time="1"
            ></StockDetailChart>
            <StockDetailChart
              title="3 Day"
              symbol={symbol}
              width={600}
              time="3"
              height={600}
            ></StockDetailChart>
            <StockDetailChart
              title="5 Day"
              symbol={symbol}
              time="5"
              width={600}
              height={600}
            ></StockDetailChart>
          </div>
          <div style={{ display: "flex", flexDirection: "row" }}>
            <StockDetailChart
              title="Daily"
              symbol={symbol}
              width={600}
              time="365"
              height={600}
            ></StockDetailChart>
            <StockDetailChart
              title="Weekly"
              symbol={symbol}
              width={600}
              time="730"
              height={600}
            ></StockDetailChart>
            <StockDetailChart
              title="Montly"
              symbol={symbol}
              time="1825"
              width={600}
              height={600}
            ></StockDetailChart>
          </div>
        </>
      )}
      {symbol !== null &&
        symbol !== undefined &&
        symbol !== indexStock &&
        indexStock.length > 0 && (
          <div>
            <Divider style={{ marginTop: "20px", marginBottom: "20px" }} />
            <Typography component="h1" color="white">
              {`${symbol} / ${indexStock}`}
            </Typography>
            <div style={{ display: "flex", flexDirection: "row" }}>
              <StockDetailChart
                title="1 Day"
                symbol={`${symbol}/${indexStock}`}
                width={600}
                height={600}
                time="1"
              ></StockDetailChart>
              <StockDetailChart
                title="3 Day"
                symbol={`${symbol}/${indexStock}`}
                width={600}
                time="3"
                height={600}
              ></StockDetailChart>
              <StockDetailChart
                title="5 Day"
                symbol={`${symbol}/${indexStock}`}
                time="5"
                width={600}
                height={600}
              ></StockDetailChart>
            </div>
            <div style={{ display: "flex", flexDirection: "row" }}>
              <StockDetailChart
                title="Daily"
                symbol={`${symbol}/${indexStock}`}
                width={600}
                height={600}
                time="365"
              ></StockDetailChart>
              <StockDetailChart
                title="Weekly"
                symbol={`${symbol}/${indexStock}`}
                width={600}
                time="730"
                height={600}
              ></StockDetailChart>
              <StockDetailChart
                title="Montly"
                symbol={`${symbol}/${indexStock}`}
                time="1825"
                width={600}
                height={600}
              ></StockDetailChart>
            </div>
          </div>
        )}
    </div>
  );
};

export default LargeChartPage;
